import { useState, useEffect } from "react";
import mesimoLogoMark from "../../../assets/logo/logo-watermark.png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "About", id: "hero" },
    { label: "Services", id: "about" },
    { label: "Work", id: "work" },
    { label: "Team", id: "team" },
    { label: "Testimonials", id: "testimonials" },
    { label: "Contact", id: "contact" },
  ];

  const scrollTo = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/80 text-slate-950 shadow-[0_15px_40px_rgba(15,23,42,0.16)] backdrop-blur-3xl backdrop-saturate-150"
          : "bg-transparent text-white"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20 md:h-24">
        {/* Logo */}
        <a
          href="#hero"
          onClick={() => scrollTo("hero")}
          className="flex items-center justify-between cursor-pointer group"
        >
          <div className="w-14 h-14 rounded-2xl overflow-hidden transition-all duration-300">
            <img
              src={mesimoLogoMark}
              alt="Mesimo Logo"
              className="w-full h-full object-cover object-left-center"
            />
          </div>
          <span className="font-bold text-lg"><span className="lowercase">m</span>esimo<span className="font-bold text-slate-600">.inc</span></span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? "text-slate-700 hover:text-slate-950" : "text-white/80 hover:text-white"
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <button
            onClick={() => scrollTo("contact")}
            className={`text-sm font-semibold px-5 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap ${
              scrolled
                ? "bg-slate-950 text-white border border-slate-950 hover:bg-slate-800"
                : "bg-white/15 backdrop-blur-sm border border-white/25 text-white hover:bg-white/25"
            }`}
          >
            Get a Quote
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer transition-colors ${
            scrolled ? "text-slate-950" : "text-white"
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className={`md:hidden px-6 py-4 flex flex-col gap-4 shadow-[0_15px_40px_rgba(15,23,42,0.12)] transition-colors ${
          scrolled
            ? "bg-slate-950/95 border-t border-slate-900/50"
            : "bg-black/70 border-t border-white/15 backdrop-blur-3xl"
        }`}>
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`text-left text-base font-medium py-1 cursor-pointer transition-colors ${
                scrolled ? "text-white/90 hover:text-white" : "text-white/80 hover:text-white"
              }`}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            className={`mt-2 text-sm font-semibold px-5 py-3 rounded-full cursor-pointer whitespace-nowrap transition-all ${
              scrolled
                ? "bg-white text-slate-950 hover:bg-slate-100"
                : "bg-white/15 border border-white/25 text-white hover:bg-white/25"
            }`}
          >
            Get a Quote
          </button>
        </div>
      )}
    </header>
  );
}
